import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from 'flowbite-react';
export const LoadingScreen = () => (_jsx("div", { className: "w-full h-full flex justify-center items-center", children: _jsx(Spinner, { className: "w-[48px] h-[48px] fill-secondary" }) }));
